import Analysis from 'domain/entity/analysis';
import { Result } from 'domain/types';
import { UpdateAnalysisClient } from 'use-case/analysis/update/updateAnalysisClient';
import AnalysisDataCriteria from 'use-case/analysis/analysisCriteria';

export type UpdateAnalysisResult = Result<Analysis>;
export type UpdateAnalysis = (criteria: AnalysisDataCriteria) => Promise<UpdateAnalysisResult>;

export const updateAnalysisUseCase = (updteAnalysisClient: UpdateAnalysisClient): UpdateAnalysis => (
    criteria: AnalysisDataCriteria
): Promise<UpdateAnalysisResult> => updteAnalysisClient(criteria);
